import React from "react";
import NumberFormat, { InputAttributes, NumberFormatPropsBase } from "react-number-format";

import { TextField, TextFieldProps } from "@mui/material";

interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
}

const NumberFormatCustom = React.forwardRef<NumberFormat<InputAttributes>, CustomProps>(
  function NumberFormatCustom(props, ref) {
    const { onChange, ...other } = props;

    return (
      <NumberFormat
        getInputRef={ref}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value
            }
          });
        }}
        thousandSeparator
        isNumericString
        {...other}
      />
    );
  }
);

export const NumberInput: React.FC<TextFieldProps & { numberInputProps?: NumberFormatPropsBase<InputAttributes> }> = ({
  numberInputProps,
  InputProps,
  ...props
}): JSX.Element => (
  <TextField
    InputProps={{
      ...InputProps,
      inputComponent: NumberFormatCustom as any
    }}
    inputProps={numberInputProps}
    {...props}
  />
);
